export default "__VITE_ASSET__BSkKQQ3V__"